export const PRIVATE_LANDLORD = 'private';
export const PROFESSIONAL_LANDLORD = 'professional';

export const LANDLORD_TYPES = [PRIVATE_LANDLORD, PROFESSIONAL_LANDLORD];

export default {
  PRIVATE_LANDLORD,
  PROFESSIONAL_LANDLORD,
  LANDLORD_TYPES
};
